export default 'visitPage';
